import { useQueryLocation } from '../hooks';

const Link = ({ href, cb, children, ...props }) => {
    const [_, navigate] = useQueryLocation();
    
    const handleClick = (e) => {
        e.preventDefault();
        
        // Allow default behavior for modified clicks (open in new tab, etc.)
        if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
            return;
        }
        
        if (cb) cb();
        navigate(href);
    };
    
    const fullHref = `${window.location.pathname}?habit-tracker${href}`;
    
    return (
        <a 
            href={fullHref}
            onClick={handleClick}
            {...props}
        >
            {children}
        </a>
    );
};

export default Link;
